<template>
  <v-form ref="form" @submit.prevent="submit" lazy-validation v-model="valid">
    <v-container :class="$vuetify.breakpoint.xsOnly ? '' : 'elevation-2'">
      <div v-if="form.file_cer">
        <v-text-field
          :label="labels.archivo_cer"
          v-model="form.file_cer.name"
          :error-messages="errors.archivo_cer"
          :rules="[rules.required('archivo_cer')]"
          :disabled="loading"
          @click="seleccionarArchivoCER()"
          append-icon="attach_file"
        ></v-text-field>
      </div>
      <div v-else>
        <v-text-field
          :label="labels.archivo_cer"
          :error-messages="errors.archivo_cer"
          :rules="[rules.required('archivo_cer')]"
          :disabled="loading"
          @click="seleccionarArchivoCER()"
          append-icon="attach_file"
        ></v-text-field>
      </div>

      <input
        type="file"
        style="display: none"
        ref="archivo_cer"
        @change="archivoCERSeleccionado($event)"
      >

      <div v-if="form.file_key">
        <v-text-field
          :label="labels.archivo_key"
          v-model="form.file_key.name"
          :error-messages="errors.archivo_key"
          :rules="[rules.required('archivo_key')]"
          :disabled="loading"
          @click="seleccionarArchivoKEY()"
          append-icon="attach_file"
        ></v-text-field>
      </div>
      <div v-else>
        <v-text-field
          :label="labels.archivo_key"
          :error-messages="errors.archivo_key"
          :rules="[rules.required('archivo_key')]"
          :disabled="loading"
          @click="seleccionarArchivoKEY()"
          append-icon="attach_file"
        ></v-text-field>
      </div>

      <input
        type="file"
        style="display: none"
        ref="archivo_key"
        @change="archivoKEYSeleccionado($event)"
      >

      <v-text-field
        :label="labels.password"
        v-model="form.password"
        :append-icon="passwordHidden ? 'visibility_off' : 'visibility'"
        @click:append="() => (passwordHidden = !passwordHidden)"
        :type="passwordHidden ? 'password' : 'text'"
        :error-messages="errors.password"
        :rules="[rules.required('password')]"
        :disabled="loading"
        hint="At least 6 characters"
      ></v-text-field>
    </v-container>
      
    <v-layout justify-end mt-2>
      <v-btn
        flat
        :disabled="loading"
        @click="$router.go(-1)"
        color="grey darken-2"
      >
        Cancelar
      </v-btn>          

      <v-btn
        type="submit"
        :loading="loading"
        :disabled="loading"
        color="primary"
      >
        Continuar
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
  import axios from 'axios'
  import { mapGetters } from 'vuex'
  import { api } from '~/config'
  import Form from '~/mixins/form'

  export default {
    mixins: [Form],

    data: () => ({

      passwordHidden: true,

      form: {
        file_cer: null,
        file_key: null,
        password: null
      }
    }),

    computed: mapGetters({
    }),

    mounted() {
    },

    methods: {
      seleccionarArchivoCER() {
        this.$refs.archivo_cer.click()
      },

      seleccionarArchivoKEY() {
        this.$refs.archivo_key.click()
      },

      archivoCERSeleccionado(e) {
        let file = e.target.files[0]
        this.form.file_cer = file
      },
      
      archivoKEYSeleccionado(e) {
        let file = e.target.files[0]
        this.form.file_key = file
      },
      
      submit() {
        if (this.$refs.form.validate()) {
          this.loading = true

          let data = new FormData();

          data.append('file_cer[]', this.form.file_cer);
          data.append('file_key[]', this.form.file_key);
          data.append('password[]', this.form.password);
          
          data.append('_method', 'PUT');

          axios
            .post(api.path('responsables.firma', { id: this.$route.params.id } ), data)
            .then(res => {
              this.$toast.success('Datos guardados correctamente.')
              this.$emit('success', res.data)
            })
            .catch(err => {
              this.$toast.error('No se pueden enviar los datos.')
              this.handleErrors(err.response.data.errors)
            })
            .then(() => {
              this.loading = false
            })
        }
      }
    }
  }
</script>
